import type { ReactNode } from 'react';

export const symbol_arrow_back_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M240-452q-7-5-10.5-11t-3.5-14q0-8 3.5-14t10.5-11l354-226q4-2 8-3t8-1q12 0 21 8t9 22v450q0 14-9 22t-21 8q-4 0-8-1t-8-3L240-452Zm340-25Zm0 171v-342L311-477l269 171Z"
		/>
	</svg>
);
